import { useQuery } from '@tanstack/react-query';
import { getBudgetLineItemSources } from '@/api/Sherpa/ChangeOrder';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { accountingFormatNumber } from '@/utils';

export function PaidFromSelect({ projectId }: { projectId: string }) {
  //Tanstack: version 5 query implementation
  const { data: sources } = useQuery({
    queryKey: ['BudgetLineItemSources'],
    queryFn: () =>
      getBudgetLineItemSources({
        refId: Number(projectId),
        refType: 'project',
      }),
  });

  const sourceOptions = sources?.map((source) => ({
    label: `${source.name} (${accountingFormatNumber({
      num: source.amount,
    })})`,
    value: source.name,
  }));

  return <HookReactSingleSelect label='Paid From' name='paidFrom' required options={sourceOptions} />;
}
